import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class AllocationService {
 
  constructor(
    private http: HttpService,
  ) { }

  validateLevelOne(data?: any) {
    return this.http.post(Path.ALLOCATION.VALIDATE_LEVEL_ONE, data);
  }

  allocateLevelOne(data?: any) {
    return this.http.post(Path.ALLOCATION.ALLOCATE_LEVEL_ONE, data);
  }

  validateLevelTwo(data?: any) {
    return this.http.post(Path.ALLOCATION.VALIDATE_LEVEL_TWO, data);
  }

  allocateLevelTwo(data?: any) {
    return this.http.post(Path.ALLOCATION.ALLOCATE_LEVEL_TWO, data);
  }

  autoDownload(allocationLevel, data?: any) {
    if(allocationLevel == 'one') {
      return this.http.post(Path.ALLOCATION.LV1_SERIES, data);
    }
    else {
      return this.http.post(Path.ALLOCATION.LV2_SERIES, data);
    }
  }

  getCampaignDistributionList(allocationLevel, data?: any) {
    if(allocationLevel == 'one') {
      return this.http.post(Path.ALLOCATION.GET_USER_CAMPAIGN_DISTRIB_LIST, data);
    } else {
      return this.http.post(Path.ALLOCATION.GET_RECIPIENT_CAMPAIGN_DISTRIB_LIST, data);
    }
  }
  
  getUserList(allocationLevel, data?: any) {
    if(allocationLevel == 'one') {
      return this.http.post(Path.ALLOCATION.GET_LV1_USER_LIST, data);
    } else {
      return this.http.post(Path.ALLOCATION.GET_LV2_USER_LIST, data);
    }
  }
  
  getDistributionCouponDetail(allocationLevel, data?: any) {
    if(allocationLevel == 'one') {
      return this.http.post(Path.ALLOCATION.GET_LV1_COUPON_DETAIL, data);
    } else {
      return this.http.post(Path.ALLOCATION.GET_LV2_COUPON_DETAIL, data);
    }
  }

  getSeries(allocationLevel, data?: any) {
    if(allocationLevel == 'one') {
      return this.http.post(Path.ALLOCATION.LV1_SERIES, data);
    } else {
      return this.http.post(Path.ALLOCATION.LV2_SERIES, data);
    }
  }

  downloadTemplateLevelOne(data?: any) {
    return this.http.post(Path.ALLOCATION.DOWNLOAD_TEMPLATE_LEVEL_ONE, data);
  }

  downloadTemplateLevelTwo(data?: any) {
    return this.http.post(Path.ALLOCATION.DOWNLOAD_TEMPLATE_LEVEL_TWO, data);
  }
  
}